'use client';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, LabelList } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
  type ChartConfig,
} from '../chart';

export interface LineSeries {
  key: string;
  label: string;
  color: string;
}

interface LineLabelChartProps {
  data: Record<string, unknown>[];
  series: LineSeries[];
  xKey: string;
  showLegend?: boolean;
  height?: number;
  className?: string;
}

export function LineLabelChart({
  data,
  series,
  xKey,
  showLegend = true,
  height = 260,
  className,
}: LineLabelChartProps) {
  const config: ChartConfig = Object.fromEntries(
    series.map((s) => [s.key, { label: s.label, color: s.color }]),
  );

  return (
    <ChartContainer config={config} className={className} style={{ height }}>
      <LineChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey={xKey} tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} width={36} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {showLegend && <ChartLegend content={<ChartLegendContent />} />}
        {series.map((s) => (
          <Line
            key={s.key}
            type="monotone"
            dataKey={s.key}
            stroke={`var(--color-${s.key})`}
            strokeWidth={2}
            dot={{ r: 4, fill: `var(--color-${s.key})` }}
          >
            <LabelList
              dataKey={s.key}
              position="top"
              offset={8}
              className="fill-foreground text-[11px]"
            />
          </Line>
        ))}
      </LineChart>
    </ChartContainer>
  );
}
